var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.99999 7.50001L14.6932 13.1932C15.1023 13.6023 15.1023 14.2841 14.6932 14.6932C14.2841 15.1023 13.6023 15.1023 13.1932 14.6932L7.49999 9L1.80681 14.6932C1.39772 15.1023 0.715909 15.1023 0.306818 14.6932C-0.102273 14.2841 -0.102273 13.6023 0.306818 13.1932L6 7.50001L0.306818 1.80682C-0.102273 1.39773 -0.102273 0.715909 0.306818 0.306818C0.715909 -0.102273 1.39772 -0.102273 1.80681 0.306818L7.49999 6.00001L13.1932 0.306818C13.6023 -0.102273 14.2841 -0.102273 14.6932 0.306818C15.1023 0.715909 15.1023 1.39773 14.6932 1.80682L8.99999 7.50001Z","fill":"#34495E"}));
}

Close.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = Close;

Close.default = Close;
